import { ProductAvailabilityTemplateItemImportPage } from "@/features/product-availability-template-item/pages/ProductAvailabilityTemplateItemImportPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/product-availability-template/$id/import",
)({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["product_availability_template.edit"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	const { id } = Route.useParams();
	return (
		<ProductAvailabilityTemplateItemImportPage productAvailabilityTemplateID={id} />
	);
}
